const formNames = {
    registrationForm: "registrationForm",
    loginForm: "loginForm",
    depositForm: "depositForm",
    withdrawForm: "withdrawForm",
    selfExclusionForm: "selfExclusion",
    timeOutLimitationForm: "timeOutLimitationForm",
    realityChecksForm: "realityChecksForm",
    depositLimitationsForm: "depositLimitationsForm",
    betLimitationsForm: "betLimitationsForm",
    profileDetailsForm: "updateProfile",
    uploadDocumentForm: "uploadDocument",
    resetPasswordForm: "resetPassword",
    changeForgottenPasswordForm: "changeForgottenPasswordForm",
    changePasswordForm: "changePassword",
    balanceHistoryForm: "balanceHistory",
    sendMessageForm: "sendMessage",
    transferForm: "transferFoundsForm",
    betHistoryFiltersForm: "betHistoryFiltersForm"
};

export default formNames;